/**
 * Bundle Widget JS â€” reads config from data attributes, handles tier selection,
 * modal, size selection, and ATC with Shopify Cart API.
 */
(function () {
  'use strict';

  var widgets = document.querySelectorAll('.bw[data-config]');
  if (!widgets.length) return;

  /* â”€â”€ Money formatter â”€â”€ */
  function fmtMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100);
    var amountWithComma = amount.replace('.', ',');
    if (!format) format = '{{amount}}';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(amountNoDecimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(amountNoDecimals))
      .replace(/\{\{\s*amount\s*\}\}/g, amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
  }

  /* â”€â”€ Tier price calculation â”€â”€ */
  function calcTierPrice(tier, varPrice, cmpPrice) {
    var total = varPrice * tier.quantity;
    var compare = (cmpPrice || varPrice) * tier.quantity;
    var dv = tier.discount_value || 0;
    switch (tier.discount_type || 'none') {
      case 'percentage':
        total = Math.round(total * (1 - dv / 100));
        break;
      case 'fixed_amount':
        total = total - dv * 100;
        if (total < 0) total = 0;
        break;
      case 'fixed_total':
        total = dv * 100;
        break;
    }
    var freeCompare = (tier.free_items || []).reduce(function (s, fi) {
      return s + (fi.compare_price || 0) * (fi.quantity || 1);
    }, 0);
    compare += freeCompare;
    return { total: total, compare: compare, savings: compare - total };
  }

  widgets.forEach(function (w) {
    var cfg;
    try {
      cfg = JSON.parse(w.dataset.config);
    } catch (e) {
      console.error('Bundle widget: invalid config JSON', e);
      return;
    }

    var variants;
    try {
      variants = JSON.parse(w.dataset.variants);
    } catch (e) {
      console.error('Bundle widget: invalid variants JSON', e);
      return;
    }

    var tiers = cfg.tiers || [];
    if (!tiers.length) return;

    var pid = w.dataset.productId;
    var handle = w.dataset.handle;
    var multiVariant = w.dataset.multiVariant === 'true';
    var moneyFmt = w.dataset.moneyFormat || '{{amount}}';
    var moId = 'bw-mo-' + pid;

    var tierEls = w.querySelectorAll('.bw-t');
    var atcBtn = w.querySelector('[data-bw-atc]');
    var errEl = w.querySelector('[data-bw-err]');
    var mo = document.getElementById(moId);

    var currentTier = cfg.default_tier || 0;
    var selectedVariant = parseInt(w.dataset.defaultVariant, 10);
    var pairSelections = {};

    /* â”€â”€ Get variant by id â”€â”€ */
    function getVar(vid) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === vid) return variants[i];
      }
      return variants[0];
    }

    /* â”€â”€ Update prices for a variant change â”€â”€ */
    function updatePrices(varId) {
      var v = getVar(varId);
      tierEls.forEach(function (tel, idx) {
        var tier = tiers[idx];
        if (!tier) return;
        var res = calcTierPrice(tier, v.p, v.c);
        var priceEl = tel.querySelector('[data-tp]');
        var cmpEl = tel.querySelector('[data-tc]');
        var svEl = tel.querySelector('[data-sv]');
        if (priceEl) priceEl.textContent = fmtMoney(res.total, moneyFmt);
        if (cmpEl) {
          cmpEl.textContent = fmtMoney(res.compare, moneyFmt);
          cmpEl.style.display = res.compare > res.total ? '' : 'none';
        }
        if (svEl && res.savings > 0) {
          svEl.textContent = 'You save ' + fmtMoney(res.savings, moneyFmt);
        }
      });
    }

    /* â”€â”€ Tier selection â”€â”€ */
    tierEls.forEach(function (tel, idx) {
      tel.addEventListener('click', function (e) {
        if (e.target.closest('.bw-sz') || e.target.closest('.bw-sc-inline')) return;
        e.preventDefault();
        tierEls.forEach(function (t) { t.classList.remove('is-on'); });
        tel.classList.add('is-on');
        var radio = tel.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        currentTier = idx;

        /* Show/hide inline size pickers */
        w.querySelectorAll('[data-bw-isz]').forEach(function (isz) {
          isz.classList.toggle('is-hidden', isz.dataset.bwIsz !== String(idx));
        });
      });
    });

    /* â”€â”€ Inline size buttons â”€â”€ */
    w.querySelectorAll('.bw-sz[data-ivar]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = btn.closest('.bw-sizes');
        if (parent) {
          parent.querySelectorAll('.bw-sz').forEach(function (b) { b.classList.remove('is-pk'); });
        }
        btn.classList.add('is-pk');
        selectedVariant = parseInt(btn.dataset.ivar, 10);
        updatePrices(selectedVariant);
      });
    });

    /* â”€â”€ Size chart inline link â”€â”€ */
    w.querySelectorAll('[data-bw-sc-open]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (mo) {
          openModal();
          showSizeChart();
        }
      });
    });

    /* â”€â”€ Modal functions â”€â”€ */
    function openModal() {
      if (!mo) return;
      mo.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!mo) return;
      mo.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function showSizeChart() {
      if (!mo) return;
      var headSizes = mo.querySelector('[data-bw-head-sizes]');
      var headSc = mo.querySelector('[data-bw-head-sc]');
      var body = mo.querySelector('[data-bw-mb]');
      var scView = mo.querySelector('[data-bw-sc-view]');
      var scBar = mo.querySelector('[data-bw-sc-toggle]');
      var foot = mo.querySelector('[data-bw-foot]');
      if (headSizes) headSizes.classList.add('bw-hidden');
      if (headSc) headSc.classList.remove('bw-hidden');
      if (body) body.style.display = 'none';
      if (scView) scView.classList.add('is-active');
      if (scBar) scBar.style.display = 'none';
      if (foot) foot.style.display = 'none';
    }

    function showPairs() {
      if (!mo) return;
      var headSizes = mo.querySelector('[data-bw-head-sizes]');
      var headSc = mo.querySelector('[data-bw-head-sc]');
      var body = mo.querySelector('[data-bw-mb]');
      var scView = mo.querySelector('[data-bw-sc-view]');
      var scBar = mo.querySelector('[data-bw-sc-toggle]');
      var foot = mo.querySelector('[data-bw-foot]');
      if (headSizes) headSizes.classList.remove('bw-hidden');
      if (headSc) headSc.classList.add('bw-hidden');
      if (body) body.style.display = '';
      if (scView) scView.classList.remove('is-active');
      if (scBar) scBar.style.display = '';
      if (foot) foot.style.display = '';
    }

    function buildPairCards(qty) {
      var mb = mo ? mo.querySelector('[data-bw-mb]') : null;
      if (!mb) return;
      mb.innerHTML = '';
      pairSelections = {};
      for (var i = 0; i < qty; i++) {
        pairSelections[i] = selectedVariant;
        var card = document.createElement('div');
        card.className = 'bw-unit';
        var lbl = document.createElement('span');
        lbl.textContent = 'Pair ' + (i + 1) + ' of ' + qty;
        card.appendChild(lbl);
        var sizesDiv = document.createElement('div');
        sizesDiv.className = 'bw-sizes';
        variants.forEach(function (v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bw-sz' + (v.id === selectedVariant ? ' is-pk' : '');
          btn.dataset.vid = v.id;
          btn.dataset.pair = i;
          btn.textContent = v.t;
          if (!v.a) btn.disabled = true;
          btn.addEventListener('click', function () {
            var parent = btn.closest('.bw-sizes'); if (parent) parent.querySelectorAll('.bw-sz').forEach(function (b) { b.classList.remove('is-pk'); });
            btn.classList.add('is-pk');
            pairSelections[parseInt(btn.dataset.pair, 10)] = parseInt(btn.dataset.vid, 10);
          });
          sizesDiv.appendChild(btn);
        });
        card.appendChild(sizesDiv);
        mb.appendChild(card);
      }
    }

    /* â”€â”€ Modal event listeners â”€â”€ */
    if (mo) {
      mo.querySelectorAll('[data-bw-mx], [data-bw-mx2]').forEach(function (x) {
        x.addEventListener('click', closeModal);
      });
      mo.addEventListener('click', function (e) {
        if (e.target === mo) closeModal();
      });
      var scToggle = mo.querySelector('[data-bw-sc-toggle]');
      if (scToggle) scToggle.addEventListener('click', showSizeChart);
      var scBack = mo.querySelector('[data-bw-sc-back]');
      if (scBack) scBack.addEventListener('click', showPairs);

      /* Modal ATC */
      var modalAtc = mo.querySelector('[data-bw-ma]');
      if (modalAtc) {
        modalAtc.addEventListener('click', function () {
          closeModal();
          doAddToCart();
        });
      }
    }

    /* â”€â”€ Add to cart â”€â”€ */
    function doAddToCart() {
      if (!atcBtn) return;
      atcBtn.classList.add('is-ld');
      atcBtn.classList.remove('is-ok');
      if (errEl) errEl.textContent = '';

      var tier = tiers[currentTier];
      if (!tier) {
        if (errEl) errEl.textContent = 'Please select a bundle tier.';
        atcBtn.classList.remove('is-ld');
        return;
      }

      var items = [];
      var qty = tier.quantity || 1;
      var bundleId = Date.now();

      if (qty > 1 && multiVariant && Object.keys(pairSelections).length > 0) {
        var grouped = {};
        Object.keys(pairSelections).forEach(function (k) {
          var vid = pairSelections[k];
          grouped[vid] = (grouped[vid] || 0) + 1;
        });
        Object.keys(grouped).forEach(function (vid) {
          items.push({
            id: parseInt(vid, 10),
            quantity: grouped[vid],
            properties: {
              _bundle_type: cfg.bundle_type || 'quantity_breaks',
              _bundle_tier: tier.label || '',
              _bundle_id: String(bundleId),
              _bundle_size: String(qty)
            }
          });
        });
      } else {
        items.push({
          id: selectedVariant,
          quantity: qty,
          properties: {
            _bundle_type: cfg.bundle_type || 'quantity_breaks',
            _bundle_tier: tier.label || '',
            _bundle_id: String(bundleId),
            _bundle_size: String(qty)
          }
        });
      }

      /* Add free items */
      (tier.free_items || []).forEach(function (fi) {
        if (fi.variant_id) {
          items.push({
            id: fi.variant_id,
            quantity: fi.quantity || 1,
            properties: {
              _bundle_type: cfg.bundle_type || 'quantity_breaks',
              _bundle_tier: tier.label || '',
              _bundle_id: String(bundleId),
              _bundle_free: 'true'
            }
          });
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart error ' + r.status);
          return r.json();
        })
        .then(function () {
          atcBtn.classList.remove('is-ld');
          atcBtn.classList.add('is-ok');
          setTimeout(function () { atcBtn.classList.remove('is-ok'); }, 1500);

          /* Broadcast theme events */
          document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
          document.dispatchEvent(new CustomEvent('theme:product:added'));
        })
        .catch(function (err) {
          atcBtn.classList.remove('is-ld');
          if (errEl) errEl.textContent = err.message || 'Something went wrong. Please try again.';
        });
    }

    /* â”€â”€ Main ATC button â”€â”€ */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var tier = tiers[currentTier];
        if (!tier) return;
        if (tier.quantity > 1 && multiVariant) {
          buildPairCards(tier.quantity);
          showPairs();
          openModal();
        } else {
          doAddToCart();
        }
      });
    }

    /* â”€â”€ Sticky cart bar integration â”€â”€ */
    var stickyAtc = document.querySelector('[data-cart-bar-bundle-atc]');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        var tier = tiers[currentTier];
        if (!tier) return;
        if (tier.quantity > 1 && multiVariant) {
          buildPairCards(tier.quantity);
          showPairs();
          openModal();
        } else {
          doAddToCart();
        }
      });
    }
  });
})();